export default __webpack_public_path__ + "static/media/ustd-icon.23c26257.svg";